module.exports = __webpack_public_path__ + "img/img2.a58116fe.png";